import { LocalStorageKey } from '@/lib/storageConstants'
import { useContext, useMemo } from 'react'
import { AuthContext } from './authContext'

/** Auth client when resolved; otherwise persisted hash so client-scoped requests can run during splash. */
export function useEffectiveClientHash(): string | null {
    const { client } = useContext(AuthContext)

    return useMemo(() => {
        if (client?.clientHash) {
            return client.clientHash
        }

        if (typeof window === 'undefined') {
            return null
        }

        return window.localStorage.getItem(LocalStorageKey.CLIENT_HASH)
    }, [client?.clientHash])
}
